<template>
  <WpLink
    v-if="postData"
    class="search-item-block bg-gray"
    :class="'type-' + postData.post_type"
    :title="postData.title.rendered.decodeHtmlEntities()"
    :url="postData.link"
  >
    <h3 class="module-title">{{ postData.title.rendered.decodeHtmlEntities() }}</h3>
    <StyledIcon class="icon" v-html="svgIcons.arrow" />
  </WpLink>
</template>

<script>
import WpLink from "@/components/elements/WpLink";
import StyledIcon from "@/components/elements/StyledIcon";

import { mapGetters } from "vuex";

export default {
  name: "search-block",
  props: ["id"],
  computed: {
    ...mapGetters(["getPageById"]),
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    }
  },
  components: {
    WpLink,
    StyledIcon
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.search-item-block {
  display: block;
  width: 100%;
  padding: 20px;
  padding-right: 60px;
  margin-bottom: 20px;
  position: relative;
  text-decoration: none;
  color: inherit;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
  &:hover {
    color: #fff;
    background-color: $purple !important;
    svg {
      g {
        fill: #fff;
      }
    }
  }
  svg {
    g {
      transition: fill 0.15s ease-in-out;
    }
  }
  .module-title {
    margin: 0;
  }
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    svg {
      top: 1px;
      position: relative;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
